import { render, staticRenderFns } from "./ForgotChangePassword.vue?vue&type=template&id=81108ce6&"
import script from "./ForgotChangePassword.vue?vue&type=script&lang=js&"
export * from "./ForgotChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports